import { useMemo } from 'react';
import { SidebarProps } from '@trukt/ui/Sidebar';
import { useOrderItems } from './useOrderItems';
import { useReportItems } from './useReportItems';

export const useSidebarItems = () => {
  const orderItems = useOrderItems();
  const reportItems = useReportItems();

  const items = useMemo<SidebarProps['items']>(
    () => [
      {
        label: 'Orders',
        items: orderItems,
        id: 'orders',
      },
      {
        label: 'Reports',
        items: reportItems.items,
        id: 'reports',
      },
    ],
    [orderItems, reportItems],
  );

  return { items, reportItems: reportItems.items, reportsQuery: reportItems.query };
};
